import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { paths } from '@mc/paths'
import { Locations } from '@mc/track-event'
import {
  getPageSourceFromPath,
  shouldHideEnterpriseCTAInNav,
  shouldScrollToForm,
} from 'components/Navigation/enterprise/utils'
import { getProducts } from '../../mobileMenuProducts'
import { AccordionMenu } from '../AccordionMenu'
import { Callout } from './EnterpriseVariant2Callout'

const Search = dynamic(
  () =>
    import(
      /* webpackChunkName: 'mobile-nav-search' */ 'components/Navigation/shared/Mobile/Search'
    ),
  { ssr: false },
)

export const EnterpriseMobileMenuVariant3 = ({
  newForBusinessPageEnabled = false,
}: {
  newForBusinessPageEnabled?: boolean
}) => {
  const { pathname, query } = useRouter()

  const products = getProducts({
    pathname,
    query: query as Record<string, string>,
    newForBusinessPageEnabled,
    onCallLinksEnabled: true,
    Callout: !shouldHideEnterpriseCTAInNav(pathname) && (
      <Callout
        pageSource={getPageSourceFromPath({ pathname, query })}
        location={Locations.NAVIGATION}
        scrollToForm={shouldScrollToForm(pathname)}
        href={
          shouldScrollToForm(pathname)
            ? '#contact-form'
            : paths.enterprisePurchase
        }
      />
    ),
    productType: 'enterprise',
  })

  return (
    <>
      <Search />
      <AccordionMenu
        products={products}
        defaultExpandedProduct='enterprise'
        productSectionClassName='mc-bg-container-tint-medium'
      />
    </>
  )
}
